// src/redux/reducers/essentialMenuReducer.js

import { combineReducers } from "redux";

import addonsSlice from "../slice/essential-menu-slice/add-ons-slice";
import allergensSlice from "../slice/essential-menu-slice/allergen-slice";
import baseSlice from "../slice/essential-menu-slice/base-slice";
import brandSlice from "../slice/essential-menu-slice/brand-slice";
import categorySlice from "../slice/essential-menu-slice/category-slice";
import crustsSlice from "../slice/essential-menu-slice/crusts-slice";
import ingredientsSlice from "../slice/essential-menu-slice/Ingredients-slice";
import saladSlice from "../slice/essential-menu-slice/salads-slice";
import sauceSlice from "../slice/essential-menu-slice/sauces-slice";
import toppingsSlice from "../slice/essential-menu-slice/toppings-slice";
import variantSlice from "../slice/essential-menu-slice/variants-slice";
import modifiersSlice from "../slice/essential-menu-slice/modifiers-slice"

const essentialMenuReducer = combineReducers({
  addOns: addonsSlice,
  allergens: allergensSlice,
  bases: baseSlice,
  brands: brandSlice,
  categories: categorySlice,
  crusts: crustsSlice,
  ingredients: ingredientsSlice,
  salads: saladSlice,
  sauces: sauceSlice,
  toppings: toppingsSlice,
  variants: variantSlice,
  modifiers : modifiersSlice,
});

export default essentialMenuReducer;
